import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import $ from 'jquery';
import { decodeHtmlEntities} from "../containers/utils";
import { withRouter } from 'react-router-dom';

import ucfirst from '../tools/ucfirst';
import ProgressBar from '../components/ProgressBar';

const AcceptedLeadView = (props) => {
  const { history, lead, page, onClose } = props;
  const data = [];
  let fieldsToShow = {
    firstname: 'First Name',
    lastname: 'Last Name',
    address: 'Address',
    city: 'City',
    zippostal: 'Zip / Postal code',
    contact_email: 'Contact Email',
    student: 'Student',
    website: 'Website',
    category: 'Category',
    jobtitle: 'Job Title',
    lead_type: 'Lead Type',
    territory: 'Territory',
    timeframe: 'Time Frame',
    company_name: 'Company Name',
    dateverified: 'Date Verified',
    cloudinstalled: 'Cloud Installed',
    telephonenumber: 'Telephone Number',
    market: 'Market',
    inpatientoupatient: 'Inpatient Outpatient',
    download: 'Download',
    download_name: 'Download Name',
    estimated_budget: 'Estimated Budget',
    pagename: 'Page Name',
    reasonforproject: 'Reasons For Project',
    requirements: 'Requirements',
    usingerp: 'Using ERP?',
    usinghr: 'Using HR?',
    currentvendor: 'Current Vendor',
  };

  switch (props.lead.market_name) {
    case 'ERP':
      fieldsToShow = {
        lead_type: 'Lead Type',
        market: 'Market',
        firstname: 'First Name',
        lastname: 'Last Name',
        company_name: 'Company',
        contact_email: 'Email',
        telephonenumber: 'Telephone',
        address: 'Address',
        city: 'City',
        zippostal: 'Zip',
        country_name: 'Country',
        website: 'Website',
        jobtitle: 'Job Title',
        industry_sector: 'Industry Sector',
        'industrysub-category': 'Industry Sub-Category',
        actual_revenue: 'Company Revenue',
        actual_number_of_users: 'Number of Users',
        actual_number_of_employees: 'Number of Employees',
        timeframe: 'Purchase Timeframe',
        reasonforproject: 'Reasons for Purchase',
        currentvendor: 'Current Vendor',
      };
      break;
    case 'HRMS':
      fieldsToShow = {
        lead_type: 'Lead Type',
        market: 'Market',
        firstname: 'First name',
        lastname: 'Last name',
        company_name: 'Company',
        companydescriptor: 'Company Descriptor',
        contact_email: 'Email',
        telephonenumber: 'Telephone',
        address: 'Address',
        city: 'City',
        state_name: 'State',
        zippostal: 'Zip',
        country_name: 'Country',
        website: 'Website',
        jobtitle: 'Job Title',
        numberofemployees: 'Number of Employees',
        timeframe: 'Purchase Timeframe',
        reasonforproject: 'Reasons for Purchase',
        currentvendor: 'Current Vendor',
      };
      break;
    case 'EHR':
      fieldsToShow = {
        lead_type: 'Lead Type',
        market: 'Market',
        firstname: 'First name',
        lastname: 'Last name',
        company_name: 'Company',
        contact_email: 'Email',
        telephonenumber: 'Telephone',
        address: 'Address',
        city: 'City',
        state_name: 'State',
        zippostcode: 'Zip',
        country_name: 'Country',
        website: 'Website',
        jobtitle: 'Job Title',
        practicespecialty: 'Specialty',
        practicesizenonrange: 'Number of Physicians',
        numberofusers: 'Number of Users',
        timeframe: 'Purchase Timeframe',
        reasonforproject: 'Reasons for Purchase',
        inpatientoutpatient: 'Inpatient Outpatient',
        currentvendor: 'Current Vendor',
      };
      break;
    case 'CRM':
      fieldsToShow = {
        lead_type: 'Lead Type',
        market: 'Market',
        firstname: 'First name',
        lastname: 'Last name',
        company_name: 'Company',
        contact_email: 'Email',
        telephonenumber: 'Telephone',
        address: 'Address',
        city: 'City',
        state_name: 'State',
        zippostal: 'Zip',
        country_name: 'Country',
        website: 'Website',
        jobtitle: 'Job Title',
        indusrty: 'Industry',
        numberofemployees: 'Number of Employees',
        numberofusers: 'Number of Users',
        timeframe: 'Purchase Timeframe',
        reasonforproject: 'Reasons for Purchase',
        currentvendor: 'Current Vendor',
      };
      break;
    case 'WMS':
      fieldsToShow = {
        lead_type: 'Lead Type',
        market: 'Market',
        firstname: 'First name',
        lastname: 'Last name',
        company_name: 'Company',
        contact_email: 'Email',
        telephonenumber: 'Telephone',
        address: 'Address',
        city: 'City',
        state_name: 'State',
        zippostal: 'Zip',
        country_name: 'Country',
        website: 'Website',
        jobtitle: 'Job Title',
        industry_sector: 'Industry Sector',
        revenue: 'Annual Revenue',
        numberofemployees: 'Number of Employees',
        numberofusers: 'Number of Users',
        ordersperday: 'Orders Per Day',
        timeframe: 'Purchase Timeframe',
        reasonforproject: 'Reasons for Purchase',
        currentvendor: 'Current Vendor',
      };
      break;
    case 'PLM':
      fieldsToShow = {
        firstname: 'First Name',
        lastname: 'Last Name',
        address: 'Address',
        city: 'City',
        state_name: 'State',
        zippostal: 'Zip / Postal code',
        contact_email: 'Contact Email',
        student: 'Student',
        website: 'Website',
        category: 'Category',
        jobtitle: 'Job Title',
        lead_type: 'Lead Type',
        timeframe: 'Time Frame',
        dateverified: 'Date Verified',
        cloudinstalled: 'Cloud Installed',
        telephonenumber: 'Telephone Number',
        download: 'Download',
        download_name: 'Download Name',
        estimated_budget: 'Estimated Budget',
        pagename: 'Page Name',
        reasonforproject: 'Reasons For Project',
        requirements: 'Requirements',
        currentvendor: 'Current Vendor',
      };
      break;
    default:
      break;
  }

  Object.keys(fieldsToShow).forEach((key) => {
    // If the property doesn't exist don't show it
    if (!Object.prototype.hasOwnProperty.call(props.lead, key)) {
      return;
    }

    let value = props.lead[key];
    if (value === null) {
      return;
    }

    const fieldName = fieldsToShow[key];

    if (Array.isArray(value)) {
      value = value.map(item => (<p key={item}>{decodeHtmlEntities(item)}</p>));
    } else if (typeof value === 'object') {
      // If certain objects are found add their value
      switch (key) {
        case 'market':
          data.push((
            <div key={key} className="detail-table-item">
              <div className="detail-table-definition">
                Market
              </div>
              <div className="detail-table-value">
                {decodeHtmlEntities(value.name)}
              </div>
            </div>
          ));
          return;
        default:
          return;
      }
    }

    if (key === 'website') {
      data.push((
        <div key={key} className="detail-table-item">
          <div className="detail-table-definition">
            Website
          </div>
          <div className="detail-table-value">
            <a href={value}>{decodeHtmlEntities(value)}</a>
          </div>
        </div>
      ));
      return;
    }

    // Capitalise the company descriptor field
    if (key === 'companydescriptor' && typeof value === 'string') {
      value = value.charAt(0).toUpperCase() + value.substr(1);
    }

    // Format qualification type
    if (key === 'qualification_type' && typeof value === 'string') {
      value = value
        .split('_')
        .map(text => text.charAt(0).toUpperCase() + text.substr(1))
        .join(' ');
    }

    if (key === 'lead_type' && value === 'Desk Validated') {
      value = 'Mql Plus';
    }


    const numericKeys = [
      'numberofusers',
      'numberofemployees',
      'actual_number_of_users',
      'actual_number_of_employees',
      'practicesizenonrange',
    ];
    if (numericKeys.includes(key)) {
      value = value.toLocaleString();
    }

    if (typeof value === 'boolean') {
      value = value ? 'Yes' : 'No';
    }

    if (typeof value === 'string') {
      value = decodeHtmlEntities(value);
    }

    data.push((
      <div key={key} className="detail-table-item">
        <div className="detail-table-definition">
          {fieldName}
        </div>
        <div className="detail-table-value">
          {value}
        </div>
      </div>
    ));
  });

  const leadData = data.reduce((acc, current) => {
    if (acc[acc.length - 1].length >= 3) {
      acc.push([]);
    }

    acc[acc.length - 1].push(current);

    return acc;
  }, [[]]).map((row) => {
    if (row[0]) {
      return (
        <div key={row[0].key} className="detail-table-row">
          {row}
        </div>
      );
    }
    return null;
  });

  let requiredfeatures = [];
  if (props.lead.requiredfeatures) {
    requiredfeatures = props.lead.requiredfeatures;
    if (Array.isArray(requiredfeatures)) {
      requiredfeatures = requiredfeatures.map(item => (<p key={item}>{decodeHtmlEntities(item)}</p>));
    }
  } else if (props.lead.requiredfunctions) {
    requiredfeatures = props.lead.requiredfunctions;
    if (Array.isArray(requiredfeatures)) {
      requiredfeatures = requiredfeatures.map(item => (<p key={item}>{decodeHtmlEntities(item)}</p>));
    }
  }
  requiredfeatures = (
    <div className="detail-table-row">
      <div className="detail-table-item">
        <div className="detail-table-definition">
          Required Features
        </div>
        <div className="detail-table-value">
          {requiredfeatures}
        </div>
      </div>
    </div>
  );
  if (props.lead.lead_type === 'Mql Plus') {
    requiredfeatures = '';
  }

  let comments = [];

  if (lead.comments) {
    comments = props.lead.comments.split('\n').map((comment, id) => {
      return <p key={id}>{decodeHtmlEntities(comment)}</p>;
    });
  }

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <div className="l-lead-modal">
        <header className="l-lead-modal-section">
          <h1 className="t-header">{decodeHtmlEntities(props.lead.company_name)}</h1>
        </header>

        <div className="l-lead-modal-divider comment">
          <header className="comment-header">
            <div className="comment-author"></div>
            {props.lead.qualified_at ? (
              <div className="comment-date">
                Qualified on:&nbsp;{moment(props.lead.qualified_at, 'M/D/YYYY HH:mm:ss a').format('MM/DD/YYYY')}
              </div>
            ) : null}
          </header>
          <div className="comment-content">
            {comments}
          </div>
        </div>

        <div className="l-lead-modal-section detail-table">
          <div className="detail-table-row">
            {leadData}
          </div>
          <div className="detail-table-row">
            <div className="detail-table-item">
              <div className="detail-table-definition">
                Download URL
              </div>
              <div className="detail-table-value">
                {props.lead.download_url != null ? decodeHtmlEntities(props.lead.download_url) : decodeHtmlEntities(props.lead.downloadurl)}
              </div>
            </div>
          </div>
          {requiredfeatures}
        </div>

        <footer className="l-lead-modal-section l-lead-modal-ctas">
          <div className="l-lead-modal-cta-ignore">
            <button type="button" onClick={handleClose} className="btn btn--emphasis btn--block btn--muted">Close</button>
          </div>
        </footer>

        <small className="t-small">
          Lead UID: { props.lead.uid }
        </small>
      </div>
    </div>
  );
};

AcceptedLeadView.propTypes = {
  lead: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(AcceptedLeadView);
